import { Component } from '@angular/core';

// A dummy dialog component just to show an overlay
@Component({
    selector: 'empty-dialog',
    template: ''  
  })
  export class EmptyDialogComponent {
    constructor() {} 
  }